/* eslint-disable arrow-body-style */
import React from 'react';
import {
  Modal,
  ButtonActionEmphasis,
  Icon,
  ButtonActionSubtle,
} from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';

import './ConfirmationModal.scss';

export interface Props {
  isOpen: boolean;
  confirmationModalClose: () => void;
  confirmationModalData: any;
  confirmationModalDataSubmit: (formInitialState: any) => void;
}

const ConfirmationModal = ({
  isOpen,
  confirmationModalClose,
  confirmationModalData,
  confirmationModalDataSubmit,
}: Props) => {
  const handleValidate = () => {
    confirmationModalDataSubmit(confirmationModalData);
    confirmationModalClose();
  };
  return (
    <Modal
      closeModal={confirmationModalClose}
      closeOnClick
      isCentered
      id="confirmation-modal"
      isOpen={isOpen}
      className="confirmation-modal"
    >
      <>
        <div className="container-fluid pt-1 grid-debug-container">
          <div className="d-flex info-container p-2">
            <div>
              <Icon
                className="mr-1"
                iconClassName=""
                screenreader="Screenreader text"
                symbol="messageInfo32"
                type="svgfile"
              />
            </div>
            <div className="mt-n-1" />
            <h2>{content.confirmModal.heading}</h2>
          </div>
          <div className="row mb-3 grid-debug-row">
            <div className="col-12 grid-debug-column">
              <div className="grid-debug-component clearfix px-2">
                {content.confirmModal.content}
              </div>
            </div>
          </div>
          <div className="row mb-3 grid-debug-row">
            <div className="col-12 grid-debug-column">
              <div className="grid-debug-component clearfix px-2">
                <div className="confirmation-modal__accname">
                  {content.confirmModal.accountName}
                  <span className="px-1">
                    {confirmationModalData.accountName}
                  </span>
                </div>
              </div>
              <div className="grid-debug-component clearfix px-2">
                <div className="confirmation-modal__accname">
                  {content.confirmModal.bsb}
                  <span className="px-1">{confirmationModalData.bsb}</span>
                </div>
              </div>
              <div className="grid-debug-component clearfix px-2">
                <div className="confirmation-modal__accname">
                  {content.confirmModal.accountNumber}
                  <span className="px-1">
                    {confirmationModalData.accountNumber}
                  </span>
                </div>
              </div>
              <div className="grid-debug-component clearfix px-2">
                <div className="confirmation-modal__accname">
                  <ButtonActionEmphasis
                    onClick={handleValidate}
                    className="account-details__button-started mt-4"
                  >
                    {content.confirmModal.btnTxt}
                  </ButtonActionEmphasis>
                  <ButtonActionSubtle
                    className="mt-4 ml-4"
                    onClick={confirmationModalClose}
                  >
                    <div className="confirmation-modal__editdetail">
                      {content.confirmModal.editDetails}
                    </div>
                  </ButtonActionSubtle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default ConfirmationModal;
